import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-card-outline",
  "use": "icon-card-outline-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 512 512\" id=\"icon-card-outline\"><title>ionicons-v5-d</title><rect x=\"48\" y=\"96\" width=\"416\" height=\"320\" rx=\"56\" ry=\"56\" style=\"fill:none;stroke:rgb(191, 203, 217);stroke-linecap:round;stroke-linejoin:round;stroke-width:32px\" /><line x1=\"48\" y1=\"192\" x2=\"464\" y2=\"192\" style=\"fill:none;stroke:rgb(191, 203, 217);stroke-linejoin:round;stroke-width:60px\" /><rect x=\"128\" y=\"300\" width=\"48\" height=\"20\" style=\"fill:none;stroke:rgb(191, 203, 217);stroke-linejoin:round;stroke-width:60px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/card-outline.svg
// module id = x5ri
// module chunks = 73